module.exports = __webpack_public_path__ + "static/img/20.2736216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/20.png
// module id = XQQu
// module chunks = 0